import * as React from "react";
import { forwardRef } from "react";
const SvgIcPlus24 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "ic-plus-24" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M13 2H11V11H2L2 13H11V22H13V13H22V11H13V2Z", fill: "currentColor" })));
const ForwardRef = forwardRef(SvgIcPlus24);
export { ForwardRef as ReactComponent };
